import { Grid, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useProyecto } from '../../../data/ProyectoContext';
import { UseSetLenguajePorPais } from '../../../hooks/UseSetLenguajePorPais';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const Destinatario = () => {

    const { proyecto, setProyecto } = useProyecto();
    const {setPromptData, promptData} = useActividadesContext();    

    const handleDestinatario = (event) => {
        const { value } = event.target;
        setProyecto({...proyecto, destinatario: value
        });
        setPromptData((prevData) => ({
            ...prevData,
            destinatario: value 
          }));
      };

      const { t } = useTranslation(); // Hook de traducción
          
              //Hook para lenguaje según país
              UseSetLenguajePorPais();

    
    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >Destinatario *</Typography>
            
            <TextField
                required
                id="contexto"
                placeholder={t('placeholderDestinatario')}
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.destinatario}
                onChange={handleDestinatario}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default Destinatario;




